module.exports = __webpack_public_path__ + "static/media/44.22b1168b.png";